import { useState } from "react";
import { useRiskAreasContext } from "@common/providers/riskAreasProvider/RiskAreasProvider";
import { GraphSegmentedOption } from "@common/components/entityGraph/GraphSegmentedControl";

export function useRiskEntityGraphDialog(initialRiskAreaId: string) {
    const [selectedRiskAreaId, setSelectedRiskAreaId] = useState(initialRiskAreaId);
    const { riskAreas } = useRiskAreasContext();

    const areaOptions: Array<GraphSegmentedOption<string>> = riskAreas.map((area) => ({ label: area.name, value: area.id }));

    return {
        selectedRiskAreaId,
        onRiskAreaChange: setSelectedRiskAreaId,
        areaOptions,
        showAreaSwitcher: areaOptions.length > 1,
    };
}
